import React, { useContext, useEffect, useRef, useState } from "react";
import { ApplicationContext } from "../../context/ApplicationContext";
import { useRouter } from "next/router";
import styles from "./TopicsPreview.module.scss";

const TopicsPreview = ({ section, topics, mobileContent, idList, parent, experiences = false }) => {
  const [offsetLeft, setOffsetLeft] = useState(0);
  const [indexWidth, setIndexWidth] = useState(50);
  const [opacity, setOpacity] = useState(0);
  const observer = useRef();
  const router = useRouter();
  const { visible } = useContext(ApplicationContext);

  const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

  useEffect(() => {
    visible = "contact";

    if (!section) {
      section = visible;
    }
    setTimeout(() => {
      const firstElement = document.querySelector('[data-id="' + section + '"]');
      if (firstElement) {
        const oLeft = firstElement.offsetLeft;
        const { width } = firstElement.getBoundingClientRect();
        setOffsetLeft(oLeft);
        setIndexWidth(width);
        setOpacity(1);
      }
    }, 500)
  }, [section]);

  useIsomorphicLayoutEffect(() => {
    if (!parent) return;

    if (!observer.current) {
      observer.current = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (idList && entry.isIntersecting && entry.intersectionRatio > 0.50) {
            const i = idList.indexOf(entry.target.id);
            if (i != -1) {
              const el = document.querySelector('[data-id="' + idList[i] + '"]');
              if (el) {
                const oLeft = el.offsetLeft;
                const { width } = el.getBoundingClientRect();
                setOffsetLeft(oLeft);
                setIndexWidth(width);

                break;
              }
            }
          }
        }
      }, { threshold: 0.50 });
      [...parent.querySelectorAll('.anchor_section[id], .anchor_section a[id]')].forEach((el) => {
        observer.current.observe(el);
      });
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
        observer.current = null;
      }
    }
  }, [parent]);

  const handleClick = (e, i) => {
    e.preventDefault();
    if (idList && idList.length > 0 && idList[i]) {
      let elemToScroll = null;
      if (i === 5) {
        elemToScroll = document.getElementById(idList[2]);
      } else {

        elemToScroll = document.getElementById(idList[i]);
      }
      if (elemToScroll) {
        // scroll to
        window.scrollTo({
          top: elemToScroll.offsetTop - (experiences ? 100 : 60),
          behavior: "smooth",
        });
      }
    }
  };


  return (
    <div className={styles.TopicsPreview}>
      <div className={styles.content}>
        {topics &&
          topics.map((d, i) =>
            <div
              key={"cont-" + i}
              data-id={idList && idList[i] || ""}
            >
              <a onClick={idList && idList[i] == 'downloads' ? null : (e) => handleClick(e, i)} href={idList && idList[i] == 'downloads' ? 'https://sanremo.themall.it/pdf/The-Mall-Sanremo-Map.pdf' : ''} target={idList && idList[i] == 'downloads' ? '_blank' : ''} rel="noreferrer">
                {d}
              </a>
              <div
                style={{
                  left: offsetLeft,
                  width: indexWidth + "px",
                  opacity: opacity,
                }}
                className={styles.index}
              >
              </div>
            </div>
          )}
      </div>
      {mobileContent && (
        <div className={styles.mobileOnly}>{mobileContent}</div>
      )}
    </div>
  );
};

export default TopicsPreview;
